<template>
  <q-page padding>
    <PageHeader
      title="Transferência Interna"
      :backRoute="{ name: 'home' }"
      backBehavior="route"
    />
    <div
      class="row col-12 q-mt-md items-center q-gutter-sm text-brand-5 text-weight-bold"
    >
      <div class="col-md-2 col-xs">
        <div class="texto-titulo-input">Unidade Origem</div>
        <SelecaoUnidade
          @enviarUnidade="receberUnidadeOrigem"
          :resetar="resetarUnidade"
        />
      </div>
      <div class="col-md-2 col-xs">
        <div class="texto-titulo-input">Unidade Destino</div>
        <SelecaoUnidade
          @enviarUnidade="receberUnidadeDestino"
          :resetar="resetarUnidade"
        />
      </div>
      <div class="col-md col-xs-12">
        <p></p>
        <q-btn
          class="q-mt-xs btn"
          no-caps
          label="Criar"
          icon="add"
          color="positive"
          @click="criarTransferenciaInterna()"
        />
      </div>
    </div>
    <div class="q-mt-xl">
      <TabelaTransferenciaCriada
        :tipoTransferencia="'transferencia_interna'"
        :atualizarTabela="atualizarTabela"
      />
    </div>
  </q-page>
</template>

<script>
import { ref } from "vue";
import { useStore } from "vuex";

import SelecaoUnidade from "../components/SelecaoUnidade.vue";
import TabelaTransferenciaCriada from "../components/TabelaTransferenciaCriada.vue";
import { useQuasar } from "quasar";
import { useRouter } from "vue-router";
import PageHeader from "../../../components/PageHeader.vue";

export default {
  components: {
    SelecaoUnidade,
    TabelaTransferenciaCriada,
    PageHeader,
  },
  setup() {
    const store = useStore();
    const quasar = useQuasar();
    const router = useRouter();

    const dados = ref({
      origem: { nome: "", id: "" },
      destino: { nome: "", id: "" },
    });
    const resetarUnidade = ref(0);
    const atualizarTabela = ref(0);

    const criarTransferenciaInterna = async () => {
      if (dados.value?.origem.id === "") {
        quasar.notify({
          message: "Selecione a unidade de origem.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      if (dados.value?.destino.id === "") {
        quasar.notify({
          message: "Selecione a unidade de destino.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      if (dados.value?.origem.id === dados.value?.destino.id) {
        quasar.notify({
          message: "A transferência não pode ser para mesma unidade.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      try {
        const response = await store.dispatch(
          "ferramentaria/criarTransferencia",
          {
            tipo: "interna",
            unidadeIdOrigem: dados.value?.origem.id,
            unidadeIdDestino: dados.value?.destino.id,
          }
        );
        resetCampo();
        atualizarTabela.value++;
        quasar.notify({
          message: "Transferência interna criada com sucesso.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        router.push({
          name: "ferramentaria-detalhe-transferencia-interna",
          params: {
            transferenciaId: response.data.resultado.transferenciaUuid,
          },
        });
      } catch (error) {
        if (error.response.data?.erros?.mensagem) {
          quasar.notify({
            message: error.response.data?.erros?.mensagem,
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
        if (error.response.data?.erro?.mensagem) {
          quasar.notify({
            message: error.response.data?.erro?.mensagem,
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
      }
    };

    const receberUnidadeOrigem = (value) => {
      if (value === null) {
        dados.value.origem = {
          nome: "",
          id: "",
        };
        return;
      }
      dados.value.origem = {
        nome: value.nome,
        id: value.id,
      };
    };

    const receberUnidadeDestino = (value) => {
      if (value === null) {
        dados.value.destino = {
          nome: "",
          id: "",
        };
        return;
      }
      dados.value.destino = {
        nome: value.nome,
        id: value.id,
      };
    };

    const resetCampo = () => {
      dados.value = {
        origem: { nome: "", id: "" },
        destino: { nome: "", id: "" },
      };
      resetarUnidade.value++;
    };

    return {
      dados,
      receberUnidadeOrigem,
      receberUnidadeDestino,
      criarTransferenciaInterna,
      resetCampo,
      resetarUnidade,
      atualizarTabela,
    };
  },
};
</script>
<style scoped>
@media (max-width: 600px) {
  .texto-titulo {
    font-size: 16px;
  }
  .texto-titulo-input {
    font-size: 12px;
  }
  .btn {
    font-size: 13px;
    margin-top: 0px;
  }
}
</style>
